import BaseModel from '../base';
import GroupModel from '../group';
import NominationModel from '../nomination';

import constants from './constants';
import glossary from './glossary';

export default class Tournament extends BaseModel {
  constructor(tour = {}, url) {
    super(tour, url);

    this.name = tour.name || '';
    this.description = tour.description || '';

    this.status = tour.status;

    this.event_id = tour.event_id;
    this.nomination_id = tour.nomination_id;
    this.event_group_id = tour.event_group_id;

    this.one_stage = tour.one_stage ?? false;

    this.nomination = tour.nomination ? new NominationModel(tour.nomination) : null;
    this.event_group = tour.event_group ? new GroupModel(tour.event_group) : null;
    this.event = tour.event;
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
